import {Environment, EnvironmentBuilder, AngularEnvironmentType} from '@pes/ui';

const VERSION: string = require('../../package.json').version;
const PES_UI_VERSION: string = require('../../node_modules/@pes/ui/package.json').version;

export const environment: Environment = EnvironmentBuilder.build(AngularEnvironmentType.PROD, VERSION, PES_UI_VERSION, true);




// WEBPACK FOOTER //
// ./src/environments/environment.ts